import React from 'react'

function NotFound({
  message = 'Data Not Found',
  colSpan = 25,
}: {
  message?: string
  colSpan?: number
}) {
  return (
    <div
      style={{
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #f2f2f2',
        fontSize: '1rem',
        color: '#333',
        backgroundColor: '#f9f9f9',
        borderRadius: '0.5rem',
        padding: '1rem',
      }}
    >
      {message}
    </div>
  )
}

export default NotFound
